<template>
  <div class="p-6">
    <div class="space-y-6">
      <div class="flex">
        <div class="rounded-lg space-y-2 w-full">
          <h2 class="font-semibold uppercase text-gray-600">
            Site Statstics
          </h2>
          <div class="flex flex-wrap -mx-4 -mt-4">
            <div class="w-1/4">
              <div class="p-4">
                <div
                  class="w-full px-8 py-4 space-x-4 flex items-center bg-white rounded shadow"
                >
                  <div>
                    <i class="material-icons text-6xl text-indigo-600">
                      person
                    </i>
                  </div>
                  <div class="font-semibold">
                    <p class="text-gray-600">Total Trips</p>
                    <p class="text-4xl">{{ stats.totalTrips }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-1/4">
              <div class="p-4">
                <div
                  class="w-full px-8 py-4 space-x-4 flex items-center bg-white rounded shadow"
                >
                  <div>
                    <i class="material-icons text-6xl text-blue-600">
                      theaters
                    </i>
                  </div>
                  <div class="font-semibold">
                    <p class="text-gray-600">Total Tickets</p>
                    <p class="text-4xl">{{ stats.tickets }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-1/4">
              <div class="p-4">
                <div
                  class="w-full px-8 py-4 space-x-4 flex items-center bg-white rounded shadow"
                >
                  <div>
                    <i class="material-icons text-6xl text-green-600">
                      attach_money
                    </i>
                  </div>
                  <div class="font-semibold">
                    <p class="text-gray-600">Current Month Cost</p>
                    <p class="text-4xl">{{ stats.monthlyCost.toFixed(2) }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-1/4">
              <div class="p-4">
                <div
                  class="w-full px-8 py-4 space-x-4 flex items-center bg-white rounded shadow"
                >
                  <div>
                    <i class="material-icons text-6xl text-teal-600">
                      local_taxi
                    </i>
                  </div>
                  <div class="font-semibold">
                    <p class="text-gray-600">Current Month Trips</p>
                    <p class="text-4xl">{{ stats.monthlyTrip }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="space-y-4">
        <h2 class="font-semibold uppercase text-gray-600">
          Rides
        </h2>
        <div class="flex justify-between items-center">
          <div class="space-x-4">
            <label class="inline-block">
              <span>From</span>
              <v-date-picker
                v-model="date.start"
                :popover="{ visibility: 'click' }"
              ></v-date-picker>
            </label>
            <label class="inline-block">
              <span>To</span>
              <v-date-picker
                v-model="date.end"
                :popover="{ visibility: 'click' }"
              ></v-date-picker>
            </label>
          </div>
          <div class="flex space-x-4 items-center">
            <div
              class="rounded border border-ilift-700 py-2 px-4 text-right"
            >
              <p class="uppercase text-sm text-gray-600">Number of Rides</p>
              <p class="text-2xl font-semibold">{{ rides.length }}</p>
            </div>
            <div
              class="rounded border border-ilift-700 py-2 px-4 text-right"
            >
              <p class="uppercase text-sm text-gray-600">Cost</p>
              <p class="text-2xl font-semibold">{{ fareSum }}</p>
            </div>
          </div>
        </div>
        <div
          class="inline-block min-w-full shadow rounded-lg overflow-hidden mt-4"
        >
          <table class="min-w-full leading-normal">
            <thead>
              <tr>
                <th
                  class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  Ride ID
                </th>
                <th
                  class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  Rider Name
                </th>
                <th
                  class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  Driver Name
                </th>
                <th
                  class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  Pick / Drop Address
                </th>
                <th
                  class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  Date
                </th>
                <th
                  class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  Ride Fare
                </th>
                <th
                  class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  Status
                </th>
              </tr>
            </thead>
            <tbody v-if="rides.length">
              <tr v-for="ride in rides" :key="ride._id">
                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                  <p class="whitespace-no-wrap">{{ ride._id }}</p>
                </td>
                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                  <p class="text-gray-900 whitespace-no-wrap">
                    {{
                      `${ride.passenger.firstName} ${
                        ride.passenger.lastName ? ride.passenger.lastName : ""
                      }`
                    }}
                  </p>
                </td>
                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                  {{ ride.driver.firstName + " " + ride.driver.lastName }}
                </td>
                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                  <div class="flex items-center space-x-2">
                    <i class="material-icons text-green-600">location_on</i>
                    <span>
                      {{ ride.pickUpAddress.name }}
                    </span>
                  </div>
                  <div class="flex items-center space-x-2">
                    <i class="material-icons text-red-600">location_on</i>
                    <span>
                      {{ ride.dropOffAddress.name }}
                    </span>
                  </div>
                </td>
                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                  <p class="text-gray-900 whitespace-no-wrap">
                    {{ formatDate(ride.pickupTimestamp) }}
                  </p>
                  <p class="mt-1 text-gray-900 whitespace-no-wrap">
                    {{ formatDate(ride.endTimestamp) }}
                  </p>
                </td>
                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                  <p class="text-gray-900 whitespace-no-wrap">
                    {{ ride.fare ? ride.fare.toFixed(2) : "0" }}
                  </p>
                </td>
                <td
                  class="px-5 py-5 border-b border-gray-200 bg-white text-sm text-right"
                >
                  <span
                    class="relative inline-block px-3 py-1 font-semibold text-green-900 leading-tight"
                  >
                    <span
                      aria-hidden=""
                      class="absolute inset-0 bg-green-200 opacity-50 rounded-full"
                    ></span>
                    <span class="relative">{{ ride.status }}</span>
                  </span>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td
                  colspan="7"
                  class="bg-white py-4 text-center text-gray-600 font-semibold"
                >
                  <div v-if="loading" class="inline-block">
                    <i class="material-icons text-6xl spin">sync</i>
                    <span class="block invisible">Loading...</span>
                  </div>
                  <div v-else class="inline-block">
                    <i class="material-icons text-6xl">warning</i>
                    <span class="block">No latest rides!</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "Dashboard",
  data() {
    return {
      date: {
        start: null,
        end: null,
      },
      stats: {
        totalTrips: 0,
        monthlyTrip: 0,
        tickets: 0,
        monthlyCost: 0,
      },
      rides: [],
      loading: false,
    };
  },
  created() {
    this.getStats();
    this.getRides();

    console.log(this.$store.getters.isLoggedIn);
  },
  computed: {
    corporateId() {
      return this.$store.state.auth.account.corporate ? this.$store.state.auth.account.corporate._id : null;
    },
    fareSum() {
      return this.rides.length
        ? this.rides
            .map(ride => ride.fare)
            .reduce((fare, current) => fare + current)
            .toFixed(2)
        : 0;
    },
  },
  watch: {
    date: {
      deep: true,
      handler() {
        this.getRides();
      },
    },
  },
  methods: {
    getStats() {
      this.$http
        .get(`/corporates/${this.corporateId}/dashboard`)
        .then(response => (this.stats = response.data))
        .catch(err => console.log(err));
    },
    getRides() {
      const { date } = this;
      let url = `/corporates/${this.corporateId}/trips?`;

      if (date.start) url += `start=${new Date(date.start).toISOString()}`;
      if (date.end) url += `&end=${new Date(date.end).toISOString()}`;

      this.loading = true;
      this.$http
        .get(url)
        .then(response => {
          this.rides = response.data;
        })
        .catch(err => console.log(err))
        .finally(() => (this.loading = false));
    },
    formatDate(date) {
      return moment(date).format("MMM D, YYYY HH:mm");
    },
  },
};
</script>
